import { Spinner } from 'construct-ui';
import { messageComponent } from '../../../components/message/message.component';
import paginationComponent from '../../../components/pagination/pagination.component';
import announcementModel from '../../../models/communication/announcement.model';
import languageModel from '../../../models/language.model';
import ViewBase from '../../view-base.view';
import { exportRetailExcelTemplate } from '../../../models/file.model'

export default function AnnouncementRecipientView() {

    ViewBase.call(this);
    var inputDatModel = { name: "", details: [], columnCount: 0, rowCount: 0, fieldTypeList: [], statusList: [], totalCount: 0, orderBy: "", pageIndex: 1, pageSize: 10, searchFrom: "", searchTo: "", title: "" };
    let list = [];
    var isLoading = false;
    var isMsgOpen = false;
    var showMsg = "";
    var msgTitle = "";
    let announcementId = "";
    let detailType = "";
    let statusSelectionNeed = '';

    let getName = (e) => {
        inputDatModel.name = e.target.value;
    }

    let _clearFilter = () => {
        inputDatModel.name = "";
        _initControls();
    }

    let _search = () => {
        inputDatModel.pageIndex = 1;
        _loadAnnouncementRecipients();
    }

    let _loadAnnouncementRecipients = () => {
        announcementModel.getAnnouncementRecipients(
            _announcementListSuccessCallBack,
            _announcementListErrorCallBack,
            announcementId, detailType, inputDatModel.pageIndex, inputDatModel.pageSize, inputDatModel.name
        )
    }

    function _announcementListSuccessCallBack(result) {
        isLoading = false;
        inputDatModel.statusList = [];
        list = result.data;
        inputDatModel.totalCount = result.total;
        inputDatModel.pageIndex = result.pageIndex;
        inputDatModel.pageSize = result.pageSize;
    }

    function _announcementListErrorCallBack(error) {
        isLoading = false;
        isMsgOpen = true;
        showMsg = error.response[0].transStatus;
        msgTitle = this.getText(error.response[0].code);
    }

    let _initControls = () => {
        _loadAnnouncementRecipients();
    }

    const _downloadExcel = () => {
        isLoading = true;
        const fileName = "Announcement Recipient List.xlsx";
        const exportConfig = {
            storedProcedureCode: "3",
            params: [
                { code: "18", value: announcementId },
                { code: "19", value: "" },
                { code: "19", value: inputDatModel.name },
                { code: "15", value: detailType },
                { code: "2", value: "" },
                { code: "3", value: "0" },
                { code: "4", value: "0" },
                { code: "17", value: "EN" }
            ],
            excelSheetNames: ["Recipient List", "Total Count"],
        };
        exportRetailExcelTemplate(exportConfig, fileName)
            .catch((error) => {
                this.handleError(error);
            }).finally(() => {
                isLoading = false;
            })
    }

    let onPageSizeChanged = (pageIndex, pageSize) => {
        inputDatModel.pageIndex = pageIndex;
        inputDatModel.pageSize = pageSize;
        _loadAnnouncementRecipients();
    }

    let onPageChanged = (pageIndex) => {
        inputDatModel.pageIndex = pageIndex;
        _loadAnnouncementRecipients();
    }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    return {
        oninit: function (vnode) {
            if (vnode.attrs.detailType) {
                detailType = vnode.attrs.detailType;
            }
            if (vnode.attrs.announcementId) {
                announcementId = vnode.attrs.announcementId;
            }
            if (vnode.attrs.statusSelectionNeed) {
                statusSelectionNeed = vnode.attrs.statusSelectionNeed;
            }

            _initControls();
        },
        onupdate: function (vnode) {
            if (vnode.attrs.statusSelectionNeed && vnode.attrs.statusSelectionNeed == 'N') {
                if (detailType != vnode.attrs.detailType) {
                    detailType = vnode.attrs.detailType;
                    _initControls();
                }
            }
        },
        view: (vnode) => {
            return [
                m('.row',
                    m(Spinner, {
                        active: isLoading,
                        background: true,
                        fill: true,
                        size: 'xl',
                    }
                    ),
                    m('.col-md-12',
                        m('.d-flex.justify-content-end.mb-2',
                            m('a.btn.btn-outline-primary.btn-search[data-bs-toggle="collapse"][href="#showSearchBarRc"][role="button"][aria-controls="showSearchBar"][aria-expanded="false"]',
                                m('span.search-arrow.me-2',
                                    m('i.bi.bi-search')
                                ), languageModel.getText("LT00000001", "Search")
                            )
                        ),
                        m('.card mb-3.searchbox.collapse[id="showSearchBarRc"]',
                            m('.card-body.py-3',
                                m('.row',
                                    m('.row',
                                        m('.col-md-6',
                                            m('label.form-label', languageModel.getText("LT00000048", "User Id/ Name")),
                                            m('input[type=text][placeholder=' + languageModel.getText("LT00000048", "User Id/ Name") + '][value="' + inputDatModel.name + '"].form-control.form-control-bg', { onchange: getName }
                                            )
                                        ),
                                        m('.col-md-6.gap-2.d-sm-flex.mt-4',
                                            m('button.btn.btn-primary.px-4.gap-3', { onclick: _search }, languageModel.getText("LT00000001", "Search")),
                                            m('button.btn.btn-white.px-4.gap-3', { onclick: _clearFilter }, languageModel.getText("LT00000031", "Clear")),
                                        ),

                                        statusSelectionNeed == 'Y' && m('.row.col-md-12.mt-2',
                                            m('.col-md-1',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]',
                                                        {
                                                            checked: detailType == "",
                                                            onclick: (e) => {
                                                                detailType = ""
                                                            }
                                                        }
                                                    ),
                                                    m('label.form-check-label', "All")
                                                )
                                            ),
                                            m('.col-md-1',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]', {
                                                        checked: detailType == "001",
                                                        onclick: (e) => {
                                                            detailType = "001"
                                                        }
                                                    }),
                                                    m('label.form-check-label', "Read")
                                                )
                                            ),
                                            m('.col-md-1',
                                                m('.form-check.form-check-inline',
                                                    m('input.form-check-input[type="radio"][name="radioType"]', {
                                                        checked: detailType == "002",
                                                        onclick: (e) => {
                                                            detailType = "002"
                                                        }
                                                    }),
                                                    m('label.form-check-label', "Unread")
                                                )
                                            )
                                        ),

                                    )
                                ))),
                        m('.card',
                            m('.card-body',
                                m('.d-flex.justify-content-end mb-2',
                                    m('a.primary-link.title-link', { onclick: _downloadExcel },
                                        m('span.card-label.mb-1.fs-7',
                                            m('i.bi.bi-file-earmark-arrow-down.me-0'), //languageModel.getText("LT00000018", "Excel Download")
                                        )
                                    )
                                ),
                                m(".table-responsive",
                                    m("table.table", [
                                        m("thead",
                                            m("tr.align-middle", [
                                                m("th", { "scope": "col" }, languageModel.getText("LT00000049", "user ID")),
                                                m("th", { "scope": "col" }, languageModel.getText("LT00000050", "User Name")),
                                                m("th", { "scope": "col" }, languageModel.getText("LT00000051", "Read/Unread")),
                                                m("th", { "scope": "col" }, languageModel.getText("LT00000052", "Read Date"))
                                            ])
                                        ),
                                        m("tbody",
                                            list.length == 0 &&
                                            m("tr", { "class": "align-middle" },
                                                m("td", { "colspan": "7" }, languageModel.getText("EM00000141", "No records found."))
                                            ),
                                            list.map(gc => [
                                                m("tr", [
                                                    m("td", gc.userID),
                                                    m("td", gc.userName),
                                                    m("td", gc.statusName),
                                                    m("td", gc.readDate)

                                                ])
                                            ]),
                                        )
                                    ])
                                ),
                                !isLoading && m(paginationComponent, { currentPage: inputDatModel.pageIndex, pageSize: inputDatModel.pageSize, totalItems: inputDatModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                            )
                        )
                    ),
                    m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed })
                ),
                this.getBaseViews()
            ]
        }
    }
}
